import { setupTheme } from '../setup-theme';
import multiTheme from './multi-theme';
window.__hubspotTheme = multiTheme;
setupTheme();